import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { resetCredentials as resetCredentialsConnect } from '../stores/credentials-store';
import { AppState, ConnectedPropsWithoutDispatch } from '../stores/redux-store';
import { ApplicationError } from '../components/ApplicationErrorBoundary/errors/ApplicationError';
import { applicationParameters } from '../utilities/application-parameters';
import { useAnalytics } from '../core/Analytics/AnalyticsProvider';
import { PageView } from '../models/analytics';
import {
  ReportsMachineView as ReportsMachineViewImport,
  ReportsMachineViewProps,
} from './ReportsMachineView';
import { ERR_REPORTS_FAILED_DESCRIBE } from './services/reports';

export type ReportsDirectorProps = PropsFromRedux & {
  ReportsMachineView?: React.ComponentType<ReportsMachineViewProps>;
};

export const ReportsDirectorPresenter = ({
  resetCredentials,
  reportDescription,
  ReportsMachineView = ReportsMachineViewImport,
  session,
}: ReportsDirectorProps) => {
  const { tinklinkAnalytics } = useAnalytics();

  if (!reportDescription) {
    throw new ApplicationError(ERR_REPORTS_FAILED_DESCRIBE);
  }

  const externalReference =
    session?.externalReference || applicationParameters.get('externalReference');

  useEffect(() => {
    const stateParameter = applicationParameters.get('state');

    if (stateParameter) {
      tinklinkAnalytics.sendInteractionEventOnce({
        view: PageView.NO_SCREEN,
        label: stateParameter,
        action: 'STATE_PARAMETER',
      });
    }
  }, [tinklinkAnalytics]);

  return (
    <ReportsMachineView
      onCancel={resetCredentials}
      reportDescription={reportDescription}
      externalReference={externalReference}
    />
  );
};

const mapDispatchToProps = {
  resetCredentials: resetCredentialsConnect,
};

const mapStateToProps = (state: AppState) => ({
  reportDescription: state.reports.reportDescription,
  session: state.session.data,
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const ReportsDirector = connector(ReportsDirectorPresenter);
